module.exports = __webpack_public_path__ + "media/images/pattern-balls.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pattern-balls.png
// module id = 72
// module chunks = 0